import { COUNTRY_DEFAULT_LOCALE } from "../../presentation/utils/countryDefaultLocale";
const resolveLocale = () => {
    var _a, _b;
    const country = ((_a = sessionStorage.getItem("country")) !== null && _a !== void 0 ? _a : "").toUpperCase();
    return (_b = COUNTRY_DEFAULT_LOCALE[country]) !== null && _b !== void 0 ? _b : "en-US";
};
export class UseCaseConvertToCurrency {
    handle(price, currency) {
        return price.toLocaleString(resolveLocale());
    }
}
